export default __webpack_public_path__ + "static/Roobert-SemiBold-833c0acbabf18cc14bb0f9cc18385e84.woff2";